import React, { useEffect, useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  List,
  ListItem,
  Divider,
  Snackbar,
  InputAdornment,
} from '@mui/material';
import SearchRounded from '@mui/icons-material/SearchRounded';
import axios from '../services/api';

const ProductBatchWiseOrder = ({ onPlaceOrder }) => {
  const [products, setProducts] = useState([]);
  const [query, setQuery] = useState('');
  const [filtered, setFiltered] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  // Fetch full stock list grouped by product_id
  useEffect(() => {
    axios
      .get('stock_grouped_by_product.php')
      .then((res) => {
        setProducts(res.data);
      })
      .catch((err) => console.error(err));
  }, []);

  // Search filtering
  useEffect(() => {
    if (query.length >= 3) {
      const lower = query.toLowerCase();
      const filteredResults = products.filter((item) =>
        item.product_name.toLowerCase().includes(lower)
      );
      setFiltered(filteredResults);
    } else {
      setFiltered([]);
    }
  }, [query, products]);

  const handleQuantityChange = (productId, batch, value, maxQty) => {
    const numeric = Math.min(Number(value), maxQty);
    setQuantities((prev) => ({
      ...prev,
      [`${productId}_${batch}`]: numeric,
    }));
  };

  const handlePlaceOrder = () => {
    const orders = [];

    filtered.forEach((product) => {
      product.batches.forEach((batch) => {
        const key = `${product.product_id}_${batch.batch}`;
        const qty = quantities[key];
        if (qty && qty > 0) {
          orders.push({
            product_id: product.product_id,
            product_name: product.product_name,
            batch: batch.batch,
            ptr: batch.ptr,
            quantity: qty,
          });
        }
      });
    });

    if (orders.length === 0) {
      alert('Please add at least one quantity');
      return;
    }

    console.log('Placed Orders:', orders);
    onPlaceOrder?.(orders);
    setSnackbarOpen(true);
    setQuantities({});
    setQuery('');
    setFiltered([]);
  };

  const productColors = ['#e3f2fd', '#f3e5f5', '#e8f5e9', '#fff3e0', '#fce4ec'];

  return (
    <Box p={2}>
      <TextField
        label="Search products"
        placeholder="Type a product name"
        InputProps={{ startAdornment: <InputAdornment position="start"><SearchRounded fontSize="small" /></InputAdornment> }}
        value={query}
        fullWidth
        onChange={(e) => setQuery(e.target.value)}
        margin="normal"
        variant="outlined"
      />

      {filtered.length === 0 ? (
        <Typography variant="body2" color="textSecondary" mt={2}>
          Type at least 3 characters to search.
        </Typography>
      ) : (
        filtered.map((product, index) => {
          const bgColor = productColors[index % productColors.length];

          return (
            <Paper
              key={product.product_id}
              style={{ backgroundColor: bgColor, marginBottom: '1rem', padding: '1rem' }}
              elevation={4}
            >
              <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                {product.product_name}
              </Typography>
              <Divider sx={{ my: 1 }} />

              {product.batches.map((batch) => {
                const key = `${product.product_id}_${batch.batch}`;
                return (
                  <ListItem key={batch.batch} disableGutters>
                    <Box
                      display="flex"
                      flexDirection="column"
                      width="100%"
                      p={1}
                      bgcolor="#ffffff"
                      borderRadius="6px"
                      boxShadow="0 1px 4px rgba(0,0,0,0.1)"
                      mb={1}
                    >
                      <Typography variant="body2">
                        <strong>Batch:</strong> {batch.batch}
                      </Typography>
                      <Typography variant="body2">
                        <strong>PTR:</strong> ₹{batch.ptr}
                      </Typography>
                      <Typography variant="body2">
                        <strong>In Stock:</strong> {batch.in_stock}
                      </Typography>

                      <TextField
                        label="Quantity"
                        type="number"
                        variant="outlined"
                        size="small"
                        inputProps={{
                          min: 0,
                          max: batch.in_stock,
                        }}
                        value={quantities[key] || ''}
                        onChange={(e) =>
                          handleQuantityChange(
                            product.product_id,
                            batch.batch,
                            e.target.value,
                            batch.in_stock
                          )
                        }
                        sx={{ mt: 1, width: '120px' }}
                      />
                    </Box>
                  </ListItem>
                );
              })}
            </Paper>
          );
        })
      )}

      {filtered.length > 0 && (
        <Box textAlign="right" mt={2}>
          <Button variant="contained" color="primary" onClick={handlePlaceOrder}>
            Place Batch-Wise Order
          </Button>
        </Box>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        message="Order placed batch-wise successfully"
      />
    </Box>
  );
};

export default ProductBatchWiseOrder;
